import { render, staticRenderFns } from "./markpickupcancel.vue?vue&type=template&id=70738310&"
import script from "./markpickupcancel.vue?vue&type=script&lang=js&"
export * from "./markpickupcancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports